import css from 'styled-jsx/css';

const styles = css.global`#hero-santander-financiamentos {
    height: 520px;
    background: #ec0000;
}

#hero-santander-financiamentos .ctn-home-24 {
    display: flex;
    /* flex-direction: column; */
    /* align-items: center; */
    /* height: 450px; */
    /* justify-content: center; */
    /* gap: 22px; */
    /* flex-direction: row-reverse; */
    /* justify-content: flex-end; */
    position: relative;
    padding-top: 40px;
    max-width: 100%;
}


#hero-santander-financiamentos .hero-img img {
    position: absolute;
    right: 16px;
    top: 40px;
    /* width: 572px; */
}

#hero-santander-financiamentos .hero-contain {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 45px;
    max-width: 100%;
    position: relative;
}

#hero-santander-financiamentos .hero-contain .hero-texts {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#hero-santander-financiamentos .hero-contain .hero-title {
    color: #FFF;
    font-family: "SantanderCondensed";
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: 43px;
    max-width: 184px;
}

#hero-santander-financiamentos .hero-contain .hero-sub-title {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0%;
    max-width: 94px;
}

#hero-santander-financiamentos .hero-buttons a {
    margin: 15px auto 0;
    width: 100%;
    max-width: 270px;
    height: 50px;
    border-radius: 80px;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 5px;
}

@media (min-width: 450px) {
    #hero-santander-financiamentos .hero-img img {
        right: 16px;
    }

    #hero-santander-financiamentos .hero-contain {
        gap: 60px;
    }

    #hero-santander-financiamentos .hero-contain .hero-title {
        font-size: 55px;
        line-height: 53px;
        max-width: 216px;
    }

    #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 16px;
        line-height: 22px;
        max-width: 167px;
    }
}

@media (min-width: 600px) {
    #hero-santander-financiamentos .ctn-home-24 {
        padding-right: 16px;
        padding-left: 16px;
        padding-top: 70px;
    }

    #hero-santander-financiamentos .hero-contain .hero-texts {
        gap: 10px;
    }

    #hero-santander-financiamentos .hero-contain .hero-title {
        font-size: 64px;
        line-height: 61px;
        max-width: 346px;
    }

    #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 21px;
        line-height: 25px;
        max-width: 303px;
    }


    #hero-santander-financiamentos .hero-buttons a {
        margin: 15px 0 0;
    }
}

@media (min-width: 800px) {

    #hero-santander-financiamentos .hero-img img {
        right: 90px;
    }

     #hero-santander-financiamentos .ctn-home-24 {
        padding-right: 45px;
        padding-left: 45px;
    }

    #hero-santander-financiamentos .hero-contain .hero-title {
        line-height: 69px;
        max-width: 577px;
    }

    #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 26px;
        line-height: 30px;
        max-width: 350px;
    }

    #hero-santander-financiamentos .hero-contain {
        gap: 45px;
    }

}

@media (min-width: 992px) {
      #hero-santander-financiamentos .hero-contain .hero-title {
        font-size: 91px;
        line-height: 85px;
        max-width: 594px;
    }

     #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 28px;
        line-height: 33px;
        max-width: 410px;
    }

    #hero-santander-financiamentos .hero-contain {
        gap: 10px;
    }
}

@media (min-width: 1280px) {
    #hero-santander-financiamentos .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
        max-width: 1208px;
    }
}

/* @media (min-width: 992px) {
    #hero-santander-financiamentos .ctn-home-24 {
        position: relative;
    }
    #hero-santander-financiamentos .hero-img img {
        position: absolute;
        right: 40px;
        top: 50px;
        width: 572px;
    }
} */

/* @media (min-width: 994px) {
    #hero-santander-financiamentos {
        padding-top: 15px;
    }

    #hero-santander-financiamentos .ctn-home-24 {
        justify-content: space-between;
        gap: 0;
    }

    #hero-santander-financiamentos .hero-img {
        max-width: 100%;
        width: 510px;
    }

    #hero-santander-financiamentos .hero-contain {
        max-width: 602px;
    }

    #hero-santander-financiamentos .hero-contain .hero-selo img {
        width: 332px;
    }

    #hero-santander-financiamentos .hero-contain .hero-title,
    #hero-santander-financiamentos .hero-contain .hero-title b {
        font-size: 63px;
        line-height: 63px;
    }

    #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 32px;
    }
}

@media (min-width: 1100px) {
    #hero-santander-financiamentos {
        padding-top: 0;
    }
} */`;

export default styles;